var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"footer blocks"},[_c('div',{staticClass:"container fbox"},[_c('div',{staticClass:"copy"},[_vm._v(" Copyright © Center for International Knowledge on Development, China. All Rights Reserved ")])])])])
}]

export { render, staticRenderFns }